import { useSearchParams } from 'react-router-dom';

export const useCurrentTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const setCurrentTab = (tab: number) => setSearchParams({ tab: tab.toString() });
  const currentTab = parseInt(searchParams.get('tab') as string, 10) || 0;

  return { currentTab, setCurrentTab };
};
